import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function Leistungen() {
  return (
    <>
      <Helmet>
        <title>Social Recruiting Leistungen Berlin | Instagram, LinkedIn & TikTok Recruiting</title>
        <meta name="description" content="Professionelle Social Recruiting Leistungen in Berlin: Instagram Recruiting, LinkedIn Recruiting, TikTok Recruiting. ✓ 8-25€/Bewerbung ✓ Seit 2009 ✓ Kostenloses Erstgespräch" />
        <meta name="keywords" content="Social Recruiting Leistungen Berlin, Instagram Recruiting Berlin, LinkedIn Recruiting Berlin, TikTok Recruiting Berlin, Mitarbeitergewinnung Services" />
        <link rel="canonical" href="https://social-recruiting-berlin.de/leistungen/" />
      </Helmet>

      <main id="main-content" role="main">
        {/* Hero Section */}
        <section className="hero hero--small">
          <div className="container">
            <div className="hero__content">
              <div className="hero__text">
                <h1 className="hero__title">
                  Social Recruiting <span className="hero__highlight">Leistungen Berlin</span>
                </h1>
                <p className="hero__subtitle">
                  Professionelle Mitarbeitergewinnung über Instagram, LinkedIn & TikTok.
                  Maßgeschneiderte Strategien für Berliner Unternehmen seit 2009.
                </p>
                <div className="hero__cta">
                  <a href="#" className="btn btn--primary btn--large" data-open-consultation data-source="Hero CTA">
                    Kostenloses Erstgespräch
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Services Overview */}
        <section className="services-overview">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">Unsere Social Recruiting Services</h2>
              <p className="section-subtitle">
                Von der Strategieentwicklung bis zur Umsetzung – alles aus einer Hand
              </p>
            </div>

            <div className="services-grid">
              {/* Instagram Recruiting */}
              <div className="service-detail">
                <div className="service-detail__header">
                  <div className="service-detail__icon">
                    <svg className="icon" viewBox="0 0 24 24">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                    </svg>
                  </div>
                  <h3 className="service-detail__title">Instagram Recruiting</h3>
                  <div className="service-detail__price">ab 8€/Bewerbung</div>
                </div>
                <p className="service-detail__description">
                  Erreichen Sie junge Talente und Fachkräfte über Instagram. Mit authentischen Inhalten
                  und gezielten Werbekampagnen gewinnen wir qualifizierte Bewerber für Ihr Berliner Unternehmen.
                </p>
                <div className="service-detail__features">
                  <h4>Instagram Recruiting umfasst:</h4>
                  <ul>
                    <li>Story Ads & Reels für maximale Reichweite</li>
                    <li>Authentische Unternehmensdarstellung</li>
                    <li>Zielgruppenanalyse und Optimierung</li>
                    <li>Performance-Tracking und Reporting</li>
                    <li>A/B-Testing verschiedener Creatives</li>
                  </ul>
                </div>
                <div className="service-detail__benefits">
                  <h4>Warum Instagram Recruiting in Berlin?</h4>
                  <ul>
                    <li>67% der Berliner nutzen Instagram täglich</li>
                    <li>Schnelle Response-Zeiten (7-14 Tage)</li>
                    <li>Kosteneffizient ab 8€ pro Bewerbung</li>
                    <li>Perfekt für junge Zielgruppen (18-35 Jahre)</li>
                  </ul>
                </div>
                <Link to="/leistungen/instagram-recruiting" className="btn btn--primary">
                  Mehr zu Instagram Recruiting
                </Link>
              </div>

              {/* LinkedIn Recruiting */}
              <div className="service-detail">
                <div className="service-detail__header">
                  <div className="service-detail__icon">
                    <svg className="icon" viewBox="0 0 24 24">
                      <path d="M20 3H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4l-1.45 1.45c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L9 20.41l1.04 1.04c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L10 18.41l1.45-1.45c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L9 16.59 7.96 15.54c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L8 18.41V6c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2h-4l1.45-1.45c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L12 20.41l-1.04-1.04c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L11 22h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>
                    </svg>
                  </div>
                  <h3 className="service-detail__title">LinkedIn Recruiting</h3>
                  <div className="service-detail__price">ab 15€/Bewerbung</div>
                </div>
                <p className="service-detail__description">
                  Professionelle B2B-Personalgewinnung über LinkedIn. Executive Search, Fachkräfte
                  und Spezialisten für Berliner Unternehmen mit höchsten Qualitätsstandards.
                </p>
                <div className="service-detail__features">
                  <h4>LinkedIn Recruiting Services:</h4>
                  <ul>
                    <li>Executive Search für Führungskräfte</li>
                    <li>InMail-Kampagnen mit 30%+ Response-Rate</li>
                    <li>Company Branding und Employer Branding</li>
                    <li>LinkedIn Premium Recruiter Lizenzen</li>
                    <li>Netzwerk-Analyse und Kandidaten-Mapping</li>
                  </ul>
                </div>
                <div className="service-detail__benefits">
                  <h4>LinkedIn Vorteile für Berlin:</h4>
                  <ul>
                    <li>4M+ Professionals in Deutschland</li>
                    <li>Perfekt für B2B und Tech-Positionen</li>
                    <li>Qualifizierte Kandidaten mit Berufserfahrung</li>
                    <li>Direkte Kontaktaufnahme möglich</li>
                  </ul>
                </div>
                <Link to="/leistungen/linkedin-recruiting" className="btn btn--primary">
                  LinkedIn Recruiting Details
                </Link>
              </div>

              {/* TikTok Recruiting */}
              <div className="service-detail">
                <div className="service-detail__header">
                  <div className="service-detail__icon">
                    <svg className="icon" viewBox="0 0 24 24">
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                    </svg>
                  </div>
                  <h3 className="service-detail__title">TikTok Recruiting</h3>
                  <div className="service-detail__price">ab 12€/Bewerbung</div>
                </div>
                <p className="service-detail__description">
                  Gen Z und junge Talente über TikTok erreichen. Kreative, virale Inhalte für
                  maximale Sichtbarkeit und authentische Arbeitgeberkommunikation in Berlin.
                </p>
                <div className="service-detail__features">
                  <h4>TikTok Recruiting Features:</h4>
                  <ul>
                    <li>Short Videos und Challenges</li>
                    <li>Influencer-Marketing und Kooperationen</li>
                    <li>Hashtag-Kampagnen für maximale Reichweite</li>
                    <li>Authentische Behind-the-Scenes Content</li>
                    <li>Gen Z spezifische Ansprache</li>
                  </ul>
                </div>
                <div className="service-detail__benefits">
                  <h4>TikTok Recruiting Benefits:</h4>
                  <ul>
                    <li>1.5M+ TikTok Nutzer in Deutschland</li>
                    <li>Sehr junge Zielgruppe (16-24 Jahre)</li>
                    <li>Viraler Effekt möglich</li>
                    <li>Authentische Arbeitgeberkommunikation</li>
                  </ul>
                </div>
                <Link to="/leistungen/tiktok-recruiting" className="btn btn--primary">
                  TikTok Recruiting erfahren
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Process Section */}
        <section className="process">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">Unser Social Recruiting Prozess</h2>
              <p className="section-subtitle">Von der Analyse bis zur erfolgreichen Besetzung – transparent und strukturiert</p>
            </div>

            <div className="process-steps">
              <div className="process-step">
                <div className="process-step__number">01</div>
                <h3 className="process-step__title">Kostenlose Analyse</h3>
                <p className="process-step__description">
                  Analyse Ihrer Recruiting-Situation und Identifikation von Optimierungspotenzialen.
                </p>
              </div>

              <div className="process-step">
                <div className="process-step__number">02</div>
                <h3 className="process-step__title">Strategie&shy;entwicklung</h3>
                <p className="process-step__description">
                  Maßgeschneiderte Strategie basierend auf Ihrer Zielgruppe und Branche.
                </p>
              </div>

              <div className="process-step">
                <div className="process-step__number">03</div>
                <h3 className="process-step__title">Content Creation</h3>
                <p className="process-step__description">
                  Professionelle Social Media Inhalte für Ihre Arbeitgebermarke.
                </p>
              </div>

              <div className="process-step">
                <div className="process-step__number">04</div>
                <h3 className="process-step__title">Kampagnen-Launch</h3>
                <p className="process-step__description">
                  Gezielte Werbekampagnen auf Instagram, LinkedIn und TikTok.
                </p>
              </div>

              <div className="process-step">
                <div className="process-step__number">05</div>
                <h3 className="process-step__title">Bewerber&shy;management</h3>
                <p className="process-step__description">
                  Professionelle Vorauswahl und Koordination der Bewerber.
                </p>
              </div>

              <div className="process-step">
                <div className="process-step__number">06</div>
                <h3 className="process-step__title">Reporting & Optimierung</h3>
                <p className="process-step__description">
                  Transparente Berichte und kontinuierliche Performance-Optimierung.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Pricing Section */}
        <section className="pricing">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">Transparente Preise für Social Recruiting Berlin</h2>
              <p className="section-subtitle">Keine versteckten Kosten – nur erfolgsbasierte Abrechnung</p>
            </div>

            <div className="pricing-table">
              <div className="pricing-card">
                <h3 className="pricing-card__title">Instagram Recruiting</h3>
                <div className="pricing-card__price">8-15€<span className="pricing-card__unit">/Bewerbung</span></div>
                <ul className="pricing-card__features">
                  <li>✓ Gezielte Instagram Ads</li>
                  <li>✓ Story & Reels Content</li>
                  <li>✓ Zielgruppen-Targeting</li>
                  <li>✓ Performance Tracking</li>
                  <li>✓ Monatliches Reporting</li>
                </ul>
                <a href="#" data-open-consultation data-source="Pricing CTA" className="btn btn--primary">
                  Kostenloses Erstgespräch
                </a>
              </div>

              <div className="pricing-card pricing-card--popular">
                <div className="pricing-card__badge">Beliebt</div>
                <h3 className="pricing-card__title">LinkedIn Recruiting</h3>
                <div className="pricing-card__price">15-25€<span className="pricing-card__unit">/Bewerbung</span></div>
                <ul className="pricing-card__features">
                  <li>✓ Executive Search</li>
                  <li>✓ InMail Kampagnen</li>
                  <li>✓ Premium Recruiter Tools</li>
                  <li>✓ Netzwerk-Analyse</li>
                  <li>✓ Direkte Kandidatenansprache</li>
                </ul>
                <a href="#" data-open-consultation data-source="Pricing CTA" className="btn btn--primary">
                  Kostenloses Erstgespräch
                </a>
              </div>

              <div className="pricing-card">
                <h3 className="pricing-card__title">TikTok Recruiting</h3>
                <div className="pricing-card__price">12-20€<span className="pricing-card__unit">/Bewerbung</span></div>
                <ul className="pricing-card__features">
                  <li>✓ Short Video Content</li>
                  <li>✓ Hashtag Challenges</li>
                  <li>✓ Influencer Marketing</li>
                  <li>✓ Gen Z Targeting</li>
                  <li>✓ Viral Marketing</li>
                </ul>
                <a href="#" data-open-consultation data-source="Pricing CTA" className="btn btn--primary">
                  Kostenloses Erstgespräch
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="faq">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">FAQ: Social Recruiting Leistungen Berlin</h2>
            </div>
            <div className="faq__content">
              <div itemScope itemType="https://schema.org/FAQPage">
                <div itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
                  <h3 itemProp="name">Welche Plattformen eignen sich am besten für mein Unternehmen?</h3>
                  <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                    <p itemProp="text">
                      Die Plattform-Wahl hängt von Ihrer Zielgruppe ab:
                      <strong>Instagram:</strong> Perfekt für junge Talente (18-35 Jahre), kreative Branchen, Gastronomie<br />
                      <strong>LinkedIn:</strong> Ideal für Fachkräfte, B2B, IT, Führungskräfte<br />
                      <strong>TikTok:</strong> Gen Z (16-24 Jahre), Start-ups, moderne Unternehmen<br />
                      In unserer kostenlosen Analyse empfehlen wir die optimale Plattform-Mix für Ihr Berliner Unternehmen.
                    </p>
                  </div>
                </div>

                <div itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
                  <h3 itemProp="name">Wie lange dauert es bis zu ersten Bewerbungen?</h3>
                  <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                    <p itemProp="text">
                      Die ersten qualifizierten Bewerbungen erhalten unsere Kunden in Berlin typischerweise
                      nach 7-14 Tagen. Instagram und TikTok wirken besonders schnell bei jungen Zielgruppen,
                      LinkedIn benötigt 10-21 Tage für Executive Positionen. Die genaue Dauer hängt von der
                      Position, Branche und Saisonalität ab.
                    </p>
                  </div>
                </div>

                <div itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
                  <h3 itemProp="name">Was passiert wenn keine Bewerbungen kommen?</h3>
                  <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                    <p itemProp="text">
                      Bei famefact arbeiten wir erfolgsbasiert: Wenn nach 30 Tagen keine qualifizierten
                      Bewerbungen eingehen, erhalten Sie Ihr Geld zurück oder wir optimieren die Kampagne kostenlos.
                      Unser Qualitätsversprechen: 80% unserer Kampagnen generieren Bewerbungen innerhalb der ersten 2 Wochen.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <div className="container">
            <div className="cta-content">
              <h2 className="cta-title">Bereit für erfolgreiches Social Recruiting in Berlin?</h2>
              <p className="cta-subtitle">
                Vereinbaren Sie jetzt Ihre kostenlose Social Recruiting Analyse und erfahren Sie,
                welche Plattformen und Strategien für Ihr Unternehmen optimal sind.
              </p>
              <div className="cta-buttons">
                <a href="#" className="btn btn--primary btn--large" data-open-consultation data-source="CTA Section">
                  Kostenloses Erstgespräch
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default Leistungen;
